module.exports = __webpack_public_path__ + "static/media/icons8-Referral.129147f6.svg";